<!-- <form [formGroup]="form_group" class="mb-2"> -->
<mat-checkbox [title]="label" class="check" [(ngModel)]="checb" [required]="mandatory" [disabled]="disabled ? true:false"
  (change)="selectedCheckbox($event)">
  {{label}}
</mat-checkbox>
<!-- <span [innerHtml]="label | HTMLFormatter"></span> -->
<!-- </form> -->
